<template>
  <v-container class="p-order" v-scroll="onScroll">
    <c-section title="保单管理">
      <v-layout class="link-wrap mb-2" ref="statusList">
        <template v-for="(item,index) in statusList">
          <a
            :key="item.title"
            :class="{active:query.status === item.value}"
            class="search-status"
            @click="query.status = item.value"
          >{{ item.title }}</a>
          <div :key="index" v-if="index < statusList.length - 1" class="vertical"></div>
        </template>
      </v-layout>
      <div class="order-list" v-loading="false">
        <ListItem v-for="item in orderList" :key="item.orderCode" :order="item"></ListItem>
      </div>
      <div class="introduce-text text-xs-center mt-4">
        <span v-if="totalPage > page.pageIndex">每页 10 条数据，滚动页面继续加载下一页</span>
        <span v-else>数据已加载完毕</span>
      </div>
    </c-section>
  </v-container>
</template>

<script>
import ListItem from "./components/ListItem";
export default {
  components: {
    ListItem
  },
  data() {
    return {
      loading: true,
      statusList: [
        { title: "全部", value: -1 },
        { title: "已出单", value: 1 },
        { title: "待支付", value: 0 }
      ],
      query: {
        status: -1
      },
      page: {
        pageIndex: 1, // 从1开始
        pageSize: 10,
        totalSize: 0
      },
      orderList: []
    };
  },
  computed: {
    totalPage() {
      if (this.page.totalSize % this.page.pageSize === 0) {
        return this.page.totalSize / this.page.pageSize;
      }
      return parseInt(this.page.totalSize / this.page.pageSize) + 1;
    }
  },
  watch: {
    "page.pageIndex"() {
      this.getData();
    },
    "query.status"() {
      this.getData();
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      const params = Object.assign(
        {
          pageIndex: this.page.pageIndex - 1, // 接口是从0开始的
          pageSize: this.page.pageSize
        },
        this.query
      );
      this.$axios
        .get("/app/api/myPolicy/listPolicy", {
          params
        })
        .then(res => {
          this.loading = false;
          this.orderList = res.data;
          this.page.totalSize = res.total;
          setTimeout(() => {
            this.$vuetify.goTo(50);
          }, 100);
        })
        .catch(err => {
          this.loading = false;
          this.$message.error("订单查询异常：" + err);
        });
    },
    onScroll() {
      if (this.page.pageIndex >= this.page.totalPage) {
        const totalHeight = document.documentElement.scrollHeight;
        const clientHeight = document.documentElement.clientHeight;
        const scrollTop = document.documentElement.scrollTop;

        if (scrollTop + clientHeight > totalHeight - 100) {
          this.page.pageIndex = this.page.pageIndex + 1;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.p-order {
  .link-wrap {
    .search-status,
    .vertical {
      margin-right: 30px;
    }
    .search-status {
      color: #666666;
    }
  }
}
</style>

